import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

import { theme } from 'theme';
import { SdmTypography } from 'components';

const CustomControlLabel = withStyles({
  root: {
    '& .MuiRadio-colorSecondary.Mui-checked': {
      color: theme.colors.primary.red,
    },
    '& .MuiRadio-colorSecondary > span > input': {
      margin: '0px !important',
      top: '0px !important',
      display: 'none !important',
    },
    '& .MuiIconButton-colorSecondary:hover': {
      background: 'none',
    },
    '& .MuiTypography-body1': {
      fontFamily: 'Suisse-Intl',
    },
  },
})(FormControlLabel);

const CustomRadioButton = ({
  title,
  description,
  options,
  footer,
  onChange,
  value,
  radioGroupOnly = false,
  disabled = false,
  notTranslatableRender = false,
  isRequired = false,
}) => {
  return (
    <>
      {radioGroupOnly ? (
        <RadioGroup
          aria-label="announcements"
          style={{ display: 'flex', flexDirection: 'row' }}
          defaultValue={'0'}
          onChange={onChange}
          value={value}
        >
          {options.map((option) => (
            <CustomControlLabel
              value={option.value}
              control={<Radio />}
              label={option?.label}
              key={option.label}
            />
          ))}
        </RadioGroup>
      ) : (
        <FormControl component="fieldset" disabled={disabled}>
          <FormLabel component="legend" style={{ marginBottom: 10 }}>
            <SdmTypography
              variant="h5"
              style={{
                margin: 0,
                color: theme.colors.primary.black,
                textTransform: 'uppercase',
              }}
            >
              {title}{' '}
              {isRequired ? (
                <span
                  style={{
                    color: theme.colors.primary.red,
                    fontWeight: 400,
                  }}
                >
                  {' '}
                  *
                </span>
              ) : null}
            </SdmTypography>
            <SdmTypography
              variant="h5Regular"
              style={{ margin: 0, color: theme.colors.primary.black }}
            >
              {description}
            </SdmTypography>
            {notTranslatableRender ? notTranslatableRender : null}
          </FormLabel>
          <RadioGroup
            aria-label="announcements"
            style={{ display: 'flex', flexDirection: 'row' }}
            defaultValue={'0'}
            onChange={onChange}
            value={value}
          >
            {options.map((option) => (
              <CustomControlLabel
                value={option.value}
                control={<Radio />}
                label={option?.label}
                key={option.label}
              />
            ))}
          </RadioGroup>
          {footer && (
            <SdmTypography
              variant={'h5Regular'}
              style={{ margin: 0, fontStyle: 'italic' }}
            >
              {footer}
            </SdmTypography>
          )}
        </FormControl>
      )}
    </>
  );
};

export default CustomRadioButton;
